import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Product from "./Product";
import PrintItemCard from "./PrintItemCard";
import { useParams, useSearchParams } from "react-router-dom";
import MSMPagination from './MSMPagination';
import Form from "react-bootstrap/Form";
import CatalogService from '../services/catalog.service';
import PrintItemService from '../services/printitem.service';
import SideFilter from './SideFilter';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isLoggedIn, getSubsite, getUser } from '../reducers/auth';
import { selectAllMenuItems } from '../reducers/menu';

const ProductList = () => {
  const { categoryId } = useParams();
  const [ searchParams, setSearchParams ] = useSearchParams();
  const [resetPagination, setResetPagination] = useState(0);
  const [range, setRange] = useState([1,12]);
  const [priceFilter, setPriceFilter] = useState(null);
  const [catalog, setCatalog] = useState([]);
  const [catalogTotal, setCatalogTotal] = useState(0);
  const [brandFilterItems, setBrandFilterItems] = useState([]);
  const [colorFilterItems, setColorFilterItems] = useState([]);
  const [brandFilter, setBrandFilter] = useState([]);
  const [colorFilter, setColorFilter] = useState([]);
  const [genderFilter, setGenderFilter] = useState([]);
  const [priceRange, setPriceRange] = useState([]);
  const [productPriceRange, setProductPriceRange] = useState(null);
  const [loading, setLoading] = useState(true);
  const featured = useSelector(state => state.featured);
  const currentSubsite = useSelector(getSubsite);
  const menuItems = useSelector(selectAllMenuItems);

  const catalogStatus = useSelector(state => state.catalog.status)

  let perPage = 12;

  // Detect whether the currently-selected category is the global "Print" category;
  // when true the catalog view renders print items instead of products.
  // Use originalCategoryName because subsites may rename categories via CategoryOverride.
  const isPrintCategory = !!(menuItems && menuItems.find(
    m => String(m.id) === String(categoryId) &&
         (m.originalCategoryName === 'Print' || m.categoryName === 'Print')
  ));

  const searchTerm = searchParams.get('searchTerm');

  const loadPrintItems = async () => {
    const items = await PrintItemService.getSubsitePrintItemCatalog();
    setCatalog(items || []);
    setCatalogTotal((items || []).length);
    setBrandFilterItems([]);
    setColorFilterItems([]);
    setProductPriceRange(null);
  };

  useEffect(() => {
    let cancelled = false;

    async function fetchMyAPI() {
      setLoading(true);
      setCatalog([]);
      if (isPrintCategory) {
        await loadPrintItems();
        if (cancelled) return;
      } else {
        const catalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchTerm, priceFilter]);
        if (cancelled) return;
        setCatalog(catalog.data);
        setCatalogTotal(catalog.count);
        setBrandFilterItems(catalog.brandFilter);
        setColorFilterItems(catalog.colors);
        if (currentSubsite.paymentOptions && currentSubsite.paymentOptions !== "itemlimit") {
          setProductPriceRange(catalog.priceRange);
        }
      }
      setRange([1, 12]);
      setResetPagination(prev => prev + 1);
      setLoading(false);
    }

    fetchMyAPI();

    return () => { cancelled = true; };
  }, [categoryId, searchTerm, isPrintCategory]);

  let content = "";

  const reloadData = async(range) => {
    setLoading(true);
    setCatalog([]);
    var newCatalog = await CatalogService.getCatalog([categoryId, range[0], range[1], searchParams.get('searchTerm'), priceFilter, brandFilter, priceRange, colorFilter, genderFilter]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange(range);
    setLoading(false);

  }

  const updateBrandFilter = async (newBrandFilter) => {
    setLoading(true);
    setBrandFilter(newBrandFilter);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter, newBrandFilter, priceRange, colorFilter, genderFilter]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
    setLoading(false);
  }

  const updateColorFilter = async (newColorFilter) => {
    setLoading(true);
    setColorFilter(newColorFilter);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter, brandFilter, priceRange, newColorFilter, genderFilter]);
    console.log("NEW CATALOG COLOR", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
    setLoading(false);
  }

  const updateGenderFilter = async (newGenderFilter) => {
    setLoading(true);
    setGenderFilter(newGenderFilter);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter, brandFilter, priceRange, colorFilter, newGenderFilter]);
    console.log("NEW CATALOG GENDER", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
    setLoading(false);
  }

  const updatePriceRange = async (newPriceRange) => {
    setLoading(true);
    console.log("NEW PRICE RANGE", newPriceRange);
    setPriceRange(newPriceRange);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter, brandFilter, newPriceRange, colorFilter, genderFilter]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
    setLoading(false);
  }

  const filterChanged = async (e) => {
    setLoading(true);
    console.log("Selected Filter", e.target.value);
    setPriceFilter(e.target.value);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), e.target.value, brandFilter, priceRange, colorFilter, genderFilter]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
    setLoading(false);
  }

  return (
    <div className="container">
        {!isPrintCategory && (
          <MSMPagination reload={reloadData} perPage={perPage} total={catalogTotal} reset={resetPagination} />
        )}
        <Container style={{marginBottom: 80}}>
      <Row>
        {!isPrintCategory && (
          <Col><SideFilter colors={colorFilterItems} brands={brandFilterItems} prices={productPriceRange} updateBrandFilter={updateBrandFilter} updatePriceRange={updatePriceRange} updateColorFilter={updateColorFilter} updateGenderFilter={updateGenderFilter}/></Col>
        )}
        <Col xs={isPrintCategory ? 12 : 10}>
        {!isPrintCategory && (
          <div>
          Sort By
            <Form.Group className="mb-3" controlId="state">
                  <Form.Select
                    name="filter"
                    onChange={filterChanged}
                    >
                      <option value="relevance">Relevance</option>
                      <option value="low">Price: Low to High</option>
                      <option value="high">Price: High to Low</option>
                     </Form.Select>
                </Form.Group>
          </div>
        )}
        <div class="product-container">
          <Container>
            {loading && (
              <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{minHeight: '200px'}}>
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </Col>
              </Row>
            )}
            {!loading && (
              <Row>
                {console.log("RENDERING CATALOG:", catalog, "length:", catalog?.length)}
                {searchParams.get('searchTerm') && catalog && catalog.length == 0 && (
                  <div className="no-results">No Results Found</div>
                )}
                {catalog && catalog.length > 0 && catalog.map(catalogItem => (
                  isPrintCategory
                    ? <PrintItemCard key={`printitem_${catalogItem.id}`} item={catalogItem} />
                    : <Product key={`product_${catalogItem.id}`} product={catalogItem} />
                ))}
              </Row>
            )}
          </Container>

        </div>

        </Col>
      </Row>
    </Container>
    </div>
  );
};
export default ProductList;